document.addEventListener('DOMContentLoaded', () => {
  const handleTabClick = (clickedButton) => {
    const specialtyId = clickedButton.dataset.specialtyId;
    const panelId = clickedButton.getAttribute('aria-controls');
    const catalog = clickedButton.closest('.procedure-links');

    const allButtons = catalog.querySelectorAll('.specialty-button');
    allButtons.forEach((btn) => {
      const isActive = btn.dataset.specialtyId === specialtyId;
      btn.classList.toggle('active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const allPanels = catalog.querySelectorAll('.procedures');
    allPanels.forEach((panel) => {
      const shouldShow = panel.id === panelId;
      panel.classList.toggle('active', shouldShow);
      if (shouldShow) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  };

  const specialtyButtons = document.querySelectorAll(
    '.procedure-links .specialty-button'
  );
  specialtyButtons.forEach((button) => {
    button.addEventListener('click', () => handleTabClick(button));
  });

  const activeProcedure = document.querySelector(
    '.procedure-links .procedure.active'
  );
  const activeSpecialty = document.querySelector(
    '.procedure-links .specialty-button.active'
  );

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const scrollElementIntoView = (element) => {
    // Find the closest horizontal scrollable container
    const container = element.closest('.specialties, .procedures');
    if (!container) {
      return;
    }

    // Get positions relative to viewport
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    // Calculate element's position relative to container's content
    const elementLeftRelativeToContainer =
			elementRect.left - containerRect.left + container.scrollLeft;
    const elementWidth = element.offsetWidth;
    const containerWidth = container.clientWidth;
    const targetScrollLeft =
			elementLeftRelativeToContainer - containerWidth + elementWidth;

    if (prefersReducedMotion) {
      container.scrollLeft = targetScrollLeft;
    } else {
      container.scrollTo({
        left:     targetScrollLeft,
        behavior: 'smooth',
      });
    }
  };

  if (activeSpecialty) {
    setTimeout(() => {
      scrollElementIntoView(activeSpecialty);
    }, 300);
  }

  if (activeProcedure) {
    setTimeout(() => {
      scrollElementIntoView(activeProcedure);
    }, 300);
  }
});
